import MarkdownPage from "../components/MarkdownPage";

export default function TermsOfServicePage() {
    return (
        <MarkdownPage
            title="Terms of Service – CV Box"
            description="Terms of service for CV Box – AI CV optimisation platform."
            markdownFile="/content/terms-of-service.md"
        />
    );
}